import { MaterialLayoutRenderer } from '@jsonforms/material-renderers';
import { rankWith, uiTypeIs } from '@jsonforms/core';
import React from 'react';
import { withJsonFormsLayoutProps } from '@jsonforms/react';

import { useResponsive } from '../../../services/hooks';

const CustomVerticalLayoutRenderer = props => {
  const isDesktop = useResponsive('up', 'lg');
  const { uischema, schema, path, visible, renderers, enabled } = props;

  const layoutProps = {
    elements: uischema.elements,
    schema,
    path,
    direction: 'column',
    visible,
    uischema,
    renderers,
    enabled
  };

  return (
    <div style={!enabled ? { filter: 'opacity(0.5)' } : {}}>
      <MaterialLayoutRenderer {...layoutProps} />
    </div>
  );
};

export default withJsonFormsLayoutProps(CustomVerticalLayoutRenderer);

export const CustomVerticalLayoutTester = rankWith(1000, uiTypeIs('CustomVerticalLayout'));
